import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../Components/Common/Button';

const ChatUserCardModal = ({ 
  user, 
  onDismissUserCard, 
  onMessageMember,
  loggedUser = false
}) => {

  const onPressMessage = () => { onMessageMember(user) };

  return (
    <div>
      <div onClick={onDismissUserCard}>
        <div>
          <div>
            <span>
              {user.name} {loggedUser ? '(You)' : null}
            </span>
          </div>

          {!loggedUser && (
            <Button onClick={() => onPressMessage()}>
              Message
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

ChatUserCardModal.propTypes = {
  user: PropTypes.object.isRequired,
  onDismissUserCard: PropTypes.func.isRequired,
  onMessageMember: PropTypes.func.isRequired,
  loggedUser: PropTypes.bool
};

export default React.memo(ChatUserCardModal);